import React, { useEffect, useState } from 'react';

const useTheme = () => {
  const [theme, setTheme] = useState<string>('');

  useEffect(() => {
    setTheme(
      window.matchMedia('(prefers-color-scheme: dark)').matches
        ? 'dark'
        : 'light'
    );
  }, []);

  return theme;
};

export default useTheme;
